export default __webpack_public_path__ + "static/media/home-icon.91e299a9.svg";